exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".relation-drop-down{\n    height: 150px;\n    overflow-y: scroll;\n    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);\n    margin-left: 1px;\n    z-index: 10000;\n    position: relative;\n    background: white;\n    margin-top: -21px;\n    border-radius: 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/relation-drop-down/relation-drop-down.component.css
// module id = 2032
// module chunks = 0